<template>
  <biodata-aviso-en-caso-emergencia :persona="persona"></biodata-aviso-en-caso-emergencia>
</template>

<script>
  export default {
    props: ['persona']
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataOtrosDatosFamiliares.vue